<template>
  <div class="bto-sb-widget bto-sb-widget-match-code">
    <div class="bto-sb-widget-content">
      <input
        type="text"
        ref="matchCodeField"
        v-model="matchCode"
        :maxlength="4"
        :placeholder="`${t('Global.EventCode')}`"
        class="bto-sb-form-input" />
      <input
        type="text"
        ref="outcomeField"
        v-model="rawOutcomeCode"
        :placeholder="`${t('w.oCode')}`"
        class="bto-sb-form-input"
        @blur="reset()"
        @keydown="handleKeyDown($event)" />
      <button type="submit" class="bto-sb-form-btn" @click="addToBetslip()">
        {{ t("Mobile.add") }}
      </button>
      <span class="bto-sb-match-code-event">
        {{ errorMessage ? errorMessage : getMatchName() }}
      </span>
      <a
        href="#"
        :title="`${t('W.betCodeInf')}`"
        class="bto-sb-match-beting-code"
        v-show="showBettingCodeInfo"
        >{{ t("W.betCodeInf") }}</a
      >
      <div
        class="bto-sb-match-code-markets"
        v-if="match && match.odds"
        v-bar="{ preventParentScroll: true }">
        <div>
          <div
            class="bto-sb-match-code-market-item"
            v-for="(odd, oddIdx) in matchOddsFiltered"
            :key="oddIdx">
            <h4>{{ odd.marketName }}</h4>
            <a
              href="javascript:void(0);"
              v-for="(outcome, idx) in odd.outcomes"
              :key="idx"
              @click="addToBetslip(outcome)">
              <i>
                {{ outcome.name }}
                <b v-if="outcome.otoIdentifier">[ {{ outcome.otoIdentifier }} ]</b>
              </i>
              <i>{{ outcome.originalDecimalOutcome | formatOddDisplay($root.oddFormat) }}</i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MatchCodeModel from './model-match-code';
  import MatchCodeRequestService from './service-match-code';

  import { toggleItem, toggleAlgoItem, isOddActive, resetQuickbet } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem } from 'bto-models/betslip';
  import { showBetslipValidation } from '@bto-services/modal';

  export default {
    name: 'MatchCodeWidget',
    data() {
      return {
        matchCode: '',
        rawOutcomeCode: '',
        match: undefined,
        errorMessage: '',
        foundOutcome: undefined,
        showBettingCodeInfo: false,
        matchOddsFiltered: [],
      };
    },
    created() {

    },
    computed: {
      outcomeCode() {
        return this.rawOutcomeCode.toLowerCase();
      },
    },
    watch: {
      matchCode() {
        if (this.matchCode.length === 4) {
          // eslint-disable-next-line
          let matchCodeService = new MatchCodeRequestService();
          matchCodeService.getParams.eventID = this.matchCode;
          matchCodeService.execute((resp) => {
            if (resp.data && resp.data.ht) {
              this.match = new MatchCodeModel(resp.data);
              this.matchOddsFiltered = this.match.odds;
              this.$refs.outcomeField.focus();
            } else {
              this.showErrorMessage();
            }
          }, () => {
            this.showErrorMessage();
          });
        }
      },
      // On every change of the outcomeCode input field  filter the outcomes
      outcomeCode() {
        this.filter();
      },
    },
    methods: {
      showErrorMessage() {
        this.matchCode = '';
        this.errorMessage = this.$translate.text('Mobile.invalidcode');
        setTimeout(() => {
          this.errorMessage = '';
        }, 2000);
      },
      getMatchName() {
        if (!this.match) {
          return '';
        }

        return `${this.match.homeTeam} ${this.t('Mobile.vs')} ${this.match.guestTeam}`;
      },
      /**
       * Filter markets and outcomes according to the outcome code (otoIdentier)
       * 
       */
      filter() {
        if (!this.match) {
          this.foundOutcome = undefined;
          return;
        }
        this.foundOutcome = undefined;
        //filter by otoIdentifier and return only markets that have outcomes with the criteria
        this.matchOddsFiltered = this.match.odds.reduce((acc, market) => {
          const outcomes = market.outcomes.filter(outcome => outcome.otoIdentifier && outcome.otoIdentifier.toLowerCase().includes(this.outcomeCode));
          // set the first outcome that has the exact otoIdentifier as the searched one. to be added to betslip
          if (!this.foundOutcome) {
            this.foundOutcome = market.outcomes.find(outcome => outcome.otoIdentifier && outcome.otoIdentifier.toLowerCase() === this.outcomeCode);
          }
          // return only markets with outcomes.
          return !outcomes.length ? acc : acc.concat(Object.assign({}, market, { outcomes }));
        }, []);
      },
      handleKeyDown(event) {
        // on enter key press add to betslip
        if (event.keyCode === 13) {
          this.addToBetslip();
        }
        // on esc key press reset search
        if (event.keyCode === 27) {
          this.reset();
        }
      },
      addToBetslip(explicitOutcome) {
        this.$refs.matchCodeField.focus();
        if (!this.foundOutcome && !explicitOutcome) {
          this.showErrorMessage();
          return;
        }

        let outcome = explicitOutcome || this.foundOutcome;
        resetQuickbet();
        const betslip_item = mapMatchToBetslipItem(
          this.match,
          outcome,
          this.match.odds.find(o => o.outcomes.find(o => o.id === outcome.id)),
          false,
          true);
        const betslipMatchItem = mapMatchToBetslipMatchItem(this.match, false);
        if (isOddActive(betslip_item)) {
          this.reset();
          return;
        }
        const error = toggleAlgoItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
        this.reset();
      },
      reset() {
        setTimeout(() => {
          this.match = undefined;
          this.matchCode = '';
          this.rawOutcomeCode = '';
          this.foundOutcome = undefined;
        }, 500);
      },
    },
  };
</script>
<style scoped>
  .bto-sb-match-code-markets {
    position: absolute !important;
    width: 300px !important;
  }
</style>
